import type { Release } from '../releases.ts';

export default {
  version: '0.9.4',
  date: '2026-10-01',
  title: 'Demo accounts follow the setting',
  summary: [
    'Fixed: with demo users switched off, the demo accounts are switched off, signed out and left off sign-in',
  ],
  features: [],
  fixes: [
    'With demo users switched off, the demo accounts are switched off and signed out, and the sign-in page stops listing them',
  ],
} satisfies Release;
